<template>
  <div class="floating-label" :class="{'is-centered' : center}">
    <input
      ref="input"
      :type="type"
      :name="name"
      :id="name"
      :autocomplete="autocomplete"
      class="input"
      :value="value"
      @input="$emit('input', $event.target.value)"
      :placeholder="placeholder"
      @keyup.enter="$emit('enter')"
      :disabled="disabled"
      :qa="qa"
    />
    <label :for="name">{{ label }}</label>
  </div>
</template>

<script>

export default {
  props: ['label', 'placeholder', 'value', 'disabled', 'autocomplete', 'type', 'name', 'center', 'qa']
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';

  $border-color: #DCDCDC;
  $placeholder-font-color: #565656;
  $input-background-color: #FFFFFF;
  $input-height: 40px;

  .floating-label {
    position: relative;
    label {
      position: absolute;
      top: calc(50% - 9.5px);
      left: 11px;
      opacity: 0;
      transition: all .3s ease;
      font-size: 0.65rem;
    }
    input {
      transition: all .1s ease;
      height: 45px;
      display: block;
    }
    input:not(:placeholder-shown) + label {
      transform: translateY(-10px);
      opacity: .7;
    }
    input:not(:placeholder-shown) {
      padding-top: 21px;
    }
  }

  .input {
    border: none;
    box-shadow: none;
    background-color: $input-background-color;
    font-family: 'Roboto';
    &::placeholder {
      color: $placeholder-font-color;
      font-weight: 300;
      opacity: 1;
    }
    &:focus {
      border: 1px solid lighten($primary, 10%);
      box-shadow: 0 0 0 0.125em lighten($primary, 40%);
    }
  }

  .is-centered {
    input {
      text-align: center;
    }
    label {
      left: 0;
      right: 0;
    }
  }

  input[type="search"]::-webkit-search-decoration,
  input[type="search"]::-webkit-search-cancel-button,
  input[type="search"]::-webkit-search-results-button,
  input[type="search"]::-webkit-search-results-decoration { display: none; }

  input::-ms-reveal,
  input::-webkit-contacts-auto-fill-button,
  input[autocomplete="off"]::-webkit-contacts-auto-fill-button,
  input[type=password]::-webkit-contacts-auto-fill-button,
  input[type=password]::-webkit-credentials-auto-fill-button
  input::-webkit-textfield-decoration-container,
  input::-webkit-caps-lock-indicator,
  input::-webkit-credentials-auto-fill-button {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 10px;
    transform: translateX(-50%);
    transform: translateY(50%);
  }

</style>
